import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
	TokenTextColor,
	CTA,
	AspectRatioContainer,
	Image,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { PortalContext } from '../../context/portal-context';

export const IdWeChargePopUp: React.FC = () => {
	const { navigationService } = React.useContext(PortalContext);

	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="16:9">
				<Image
					src="https://assets.volkswagen.com/is/image/volkswagenag/alerta_club_campana_id_wecharge_2560x1706px?Zml0PWNyb3AlMkMxJndpZD0yNTU5JmhlaT0xNzA2JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjc2NmI="
					alt="Imagen bono"
					style={{ borderRadius: '16px', objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text
					appearance={TokenTextAppearance.headline300}
					textAlign={TextAlignment.center}
					color={TokenTextColor.primary}
				>
					Estrena eléctrico y{' '}
					<Text
						appearance={TokenTextAppearance.headline300}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
						bold
					>
						te invitamos a 10.000km de carga*
					</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.bigcopy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						Dar el paso a la movilidad eléctrica ahora tiene más ventajas que nunca. <br />
						<br /> Por formar parte del Club Volkswagen,{' '}
						<b>te regalamos hasta 10.000km estimados de carga pública en toda la red de We Charge*, </b>
						con más de 900.000 puntos de carga públicos repartidos por toda Europa. Para que descubras una nueva forma
						de conducir: igual de emocionante y mucho más sostenible.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center} bold>
						¿Cómo podrás disfrutar de tu carga gratuita?
					</Text>
					<Text
						appearance={TokenTextAppearance.bigcopy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						Hazte con tu Volkswagen eléctrico y obtendrás un bono en tu área de cliente que podrás canjear en la app
						Volkswagen para empezar a disfrutar de tu carga gratuita.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.bigcopy100} textAlign={TextAlignment.center} bold>
						¿Ya has elegido tu Volkswagen eléctrico?
					</Text>
					<Text
						appearance={TokenTextAppearance.bigcopy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.primary}
					>
						Explora nuestra gama ID. y elige el modelo que mejor se adapta a ti. No solo tienen tecnología y diseño
						Volkswagen, también vienen con
						<b>
							{' '}
							las ventajas de la etiqueta 0, acceso a zonas de bajas emisiones y ayudas de hasta 7.000€ con el Plan
							MOVES III del Gobierno
						</b>
						.
					</Text>
				</Container>

				<Container
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<CTA
						tag="button"
						aria-label="CTA vouchers redirect"
						size="large"
						emphasis="primary"
						onClick={() => {
							const target = navigationService.navigateTo('ofertas-electricos', {});
							if (target) {
								target.push();
								console.log('target', target);
								return true;
							} else {
								console.log('target', target);
								return false;
							}
						}}
					>
						<Text> Encuentra tu eléctrico</Text>
					</CTA>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.copy100}
						textAlign={TextAlignment.center}
						color={TokenTextColor.tertiary}
					>
						*Promoción aplicable a pedidos de clientes particulares de vehículos 100 % eléctricos realizados entre el
						01/10/2025 y el 31/12/2025, ambos inclusive. Al adquirir un modelo de la gama ID. de Volkswagen Turismos,
						los clientes particulares recibirán un bono de carga pública con un importe de 733 €, que se podrá canjear
						únicamente en las estaciones de recarga que forman parte de WeCharge, el servicio de recarga disponible en
						la aplicación Volkswagen. Este bono de 733 € corresponde a una estimación orientativa del coste de 10.000 km
						de carga pública (calculado en base a un consumo WLTP homologado de 15,9 kWh/100 km para el modelo ID.4 Pro,
						recargando en la red IONITY a 0,37 €/kWh mediante la tarifa WeCharge Plus; importe de 588,30€) más el
						importe equivalente a 12 mensualidades de dicha tarifa (11,99 €/mes, total 143,88 €). Esta estimación no es
						vinculante y puede variar según el uso real del vehículo, las condiciones de carga y las tarifas eléctricas
						aplicables. El bono puede utilizarse con cualquier suscripción activa de WeCharge. El cliente deberá abonar
						las mensualidades de la suscripción que elija, y el valor equivalente incluido en el bono podrá redimirse en
						forma de kWh de carga pública. El bono deberá activarse en un plazo máximo de tres meses desde la entrega
						del vehículo, y para ello el cliente deberá estar registrado en el Club Volkswagen a través del siguiente
						enlace: {' '}
						<a href="https://www.volkswagen.es/es/clientes/mi-club-volkswagen.html" style={{ color: '#3C484D' }}>
							https://www.volkswagen.es/es/clientes/mi-club-volkswagen.html
						</a>
						. El importe del bono deberá consumirse antes del 31/12/2029.No canjeable por dinero en metálico.
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
